import React, { useState, useEffect } from 'react';
import AuthenticatedComponent from '../../AuthenticatedComponent';
import WaitingListService from '../../../services/WaitingListService';
import PersonService from '../../../services/PersonService';
import EditWaitingListEntryComponent from './EditWaitingListEntryComponent';
import { formatStringDate } from '../../../helpers/dateFormatter';

function WaitingListEntryComponent(props) {
    const getInitialReferer = () => ({
        id: null,
        title: null,
        firstname: null,
        middlename: null,
        lastname: null,
        address: null,
        postcode: null,
        suburb: null,
        phone: null,
        work: null,
        email: null,
    });

    const [editEntry, setEditEntry] = useState(false);
    const [referer, setReferer] = useState(getInitialReferer());
    useEffect(() => {
        if (!!props.waitingListEntry.referer_id && props.waitingListEntry.waiting_list_type_id === 2) {
            PersonService.get(props.waitingListEntry.referer_id).then((person) => {
                setReferer(person);
            });
        }
    }, [props.waitingListEntry.referer_id, props.waitingListEntry.waiting_list_type_id]);

    const updateReferer = (referer) => {
        setReferer(referer);
    };

    const redigerClick = () => {
        setEditEntry(!editEntry);
    };

    const deleteEntry = () => {
        if(props.isWaitingList){
            WaitingListService.deleteWaitinglistEntry(props.waitingListEntry);
        } else {
            WaitingListService.deleteApplication(props.waitingListEntry);
        }
        props.toggleShowInfo();
    };

    return (<tr>
        {!editEntry ?
            <td colSpan="6">
                <div className="panel panel-default">
                    <div className="panel-body textAlignLeft" >
                        <div className="row">
                            {props.waitingListEntry.waiting_list_type_id === 2 &&
                                <React.Fragment>
                                    <div className="col-md panelRowPadding">
                                        <label>Referere navn</label><br />
                                        {referer.firstname} {referer.lastname}
                                    </div>
                                    <div className="col-md panelRowPadding">
                                        <label>Referere Address</label><br />
                                        {referer.address} {referer.postcode} {referer.suburb}
                                    </div>
                                    <div className="col-md panelRowPadding">
                                        <label>Referere Email</label><br />
                                        {referer.email}
                                    </div>
                                    <div className="col-md panelRowPadding">
                                        <label>Referere Telefon</label><br />
                                        {referer.phone}
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                        <div className="row">
                            <div className="col-md-6 panelRowPadding">
                                <label>Dato for indskrivelse</label><br />
                                {formatStringDate(props.waitingListEntry.entry_date)}
                            </div>
                            {
                                props.waitingListEntry.note &&
                                <div className="col-md-6 panelRowPadding">
                                    <label>Noter</label><br />
                                    {props.waitingListEntry.note}
                                </div>
                            }
                            <div className="col-md-6 panelRowPadding">
                                <label>Betalingsdetaljer</label><br />
                                Sidste betalingsdato: <b>{formatStringDate(props.waitingListEntry.last_payment_date)}</b><br />
                                Sidste betalingsbeløb : <b>{props.waitingListEntry.last_payment_date&&props.waitingListEntry.last_payment_amount/100}</b><br />
                                Sidste betalingsreference: <b>{props.waitingListEntry.last_payment_id}</b>
                            </div>

                        </div>
                        <div className="row">
                            <div className=" col-md-offset-6 col-md-3 panelRowPadding">
                                <button className="btn btn-primary" onClick={deleteEntry}>Slet</button>
                            </div>
                            <div className="col-md-3 panelRowPadding">
                                <button className="btn btn-primary" onClick={redigerClick}>Rediger</button>
                            </div>
                        </div>

                    </div>
                </div>
            </td>

            :
            <EditWaitingListEntryComponent updateReferer={updateReferer} isWaitingList={props.isWaitingList} waitingListEntry={props.waitingListEntry} referer={referer} redigerClick={redigerClick} ></EditWaitingListEntryComponent>
        }
    </tr>);
}

export default AuthenticatedComponent(WaitingListEntryComponent);